import styled from 'styled-components';

const SmallRead = () => {
  return <SmallReadStyle>SmallRead</SmallReadStyle>;
};

export default SmallRead;

const SmallReadStyle = styled.div``;
